import {
  put,
  fork,
  takeLatest
} from 'redux-saga/effects';
import {NORMALIZE_DATA} from '../../dataProvider/dataProvider';
import {SET_DATA} from './plan';

// WATCHERS
export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

// WORKERS
export function* normalizeWorker({key, data, meta}) {
  if (key !== 'plan') {
    return;
  }

  yield put({
    type: SET_DATA,
    payload: {
      ...meta,
      servicePackages: data.servicePackages,
      currentPlan: data.currentPlan,
      totalAmount:  data.monthlyTotalAmount,
      charges: data.charges,
      channels: data.channels,
      additionalServices: data.additionalServices,
      eligibility: {
        managePlanUpgradeCenterUrl: data.managePlanUpgradeCenterUrl,
        enableADManagePlanFlow: data.enableADManagePlanFlow
      },
      enableManageChannel: data.enableManageChannel,
      enableManageEquipment: data.enableManageEquipment,
      isStreamingVideoCustomer: data.isStreamingVideoCustomer,
      addAdjustCapability: data.myPlanAddAdjustCapability
    }
  });
}

export default function* customerSagas() {
  yield [
    fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/plan/planSagas.js
 **/